import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { GeneralDivision, SelectableDivisions, SelectableDivisionsListItem, ReportDepStateDto } from '../types';
import { SearchParamsT } from '../components/reports/ReportDetailDep';
import i18next from 'i18next';
import { notification, NotificationType } from '@iba-team/portal-react-components/dist';

const initialSavedState: ReportDepStateDto = [
  {
    element: 'SELECTED_DIVISION',
    value: null,
  },
  {
    element: 'PAGE_SIZE',
    value: null,
  }
];

class ReportDetailDep{
  isReportDownloading = false;
  isSavedStateFetched = false;
  isSelectableDivisionsFetched = false;
  generalDivision: GeneralDivision ={
    fetched: false,
    dataGrid: { list: [], onPage: 0, page: 0, perPage: 0, total: 0, firstNameAndLastNameOfInvalidUsers: [] },
    header: { departmentPercentages: [], generalPercentage: 0 },
  };
  selectableDivisions: SelectableDivisions = { list: [], selectedItem: {  hierarchyId: 0,
    hierarchyName: '',
    hierarchyPath: '',
  },
  perPage: 20,
  };

  savedState: ReportDepStateDto = [...initialSavedState];

  constructor() {
    makeAutoObservable(this);
  }

  getSavedState = async () => {
    try {
      this.isSavedStateFetched = false;
      this.savedState = await apiConfig.reportService.fetchDepartmentReportState();
      this.isSavedStateFetched = true;
    }
    catch (e) {
      this.savedState = [...initialSavedState];
      this.isSavedStateFetched = false;
    }
  };
  setSavedState = async (data: ReportDepStateDto) => {
    try {
      await apiConfig.reportService.setDepartmentReportState(data);
      this.savedState = [...data];
    }
    catch (e) {
      // to add handling later if necessary
    }
  };

  downloadReport = async (payload: SelectableDivisionsListItem) => {
    this.isReportDownloading = true;
    let res;
    try{
      notification.open({
        type: NotificationType.INFO,
        description: i18next.t('MSG0016'),
      });
      res = await apiConfig.reportService.downloadDepartmentReportData(payload);
      this.isReportDownloading = true;
    }
    catch (e) {
      this.isReportDownloading = false;
    }
    finally {
      this.isReportDownloading = false;
    }
    return res;
  };
  getGeneralDivision = async (payload: SearchParamsT)=>{
    this.generalDivision.fetched = false;
    try{
      const response = await apiConfig.reportService.getGeneralDivision(payload);
      this.generalDivision = {
        fetched: true,
        header: response.header,
        dataGrid: {...response.dataGrid, list: response.dataGrid.list.map((item,index)=> ({...item, key: response.dataGrid.perPage*(response.dataGrid.page-1)+index+1 }))},
      };
      // this.generalDivision.dataGrid = prepareIndexGrid(response);
    }
    catch (e) {
      this.generalDivision.fetched = false;
    }
  };

  getSelectableDivisions = async () => {
    this.isSelectableDivisionsFetched = false;
    try {
      this.selectableDivisions = await apiConfig.reportService.getSelectableDivisions();
      this.isSelectableDivisionsFetched = true;
    } catch (e) {
      this.isSelectableDivisionsFetched = false;
    }
  };
}

export const ReportGeneralDepStore = new ReportDetailDep();
